import type { BaseElement } from 'slate';

import type { AlineText, InsertBookmarkEdit } from '../../internal';

export type BookmarkStart = 'bookmarkStart';
export type BookmarkEnd = 'bookmarkEnd';
export const bookmarkStartType: BookmarkStart = 'bookmarkStart';
export const bookmarkEndType: BookmarkEnd = 'bookmarkEnd';

export interface BookmarkStartElement extends BaseElement {
  children: AlineText[];
  markerId: number;
  name: string;
  type: BookmarkStart;
  suggestedEdits?: InsertBookmarkEdit[] | null;
}

export interface BookmarkEndElement extends BaseElement {
  children: AlineText[];
  markerId: number;
  type: BookmarkEnd;
  suggestedEdits?: InsertBookmarkEdit[] | null;
}

export type BookmarkMarkerElement = BookmarkStartElement | BookmarkEndElement;
